import { call, select, put } from 'redux-saga/effects';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import {
  getFttrAvailability as getFttrAvailabilityBit,
} from '../bitSagas/getFttrAvailability';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { getFiberProductOfPackProduct, hasPackProductAvailable } from './normalizers/fttr';
import { commonActions } from '../reducers/common';

const offerStore = state => state.offer;
const getErrorManagement = state => state.errorManagement;

export function* getFttrAvailability(params) {
  yield put(loaderControlActions.setLoaderState({ loading: true }));

  const { showError, normalizeHttpErrors } = params;
  const { productOffering } = yield select(offerStore);

  const reduxUpdate = { errorUpdate: showError };
  const getFttrAvailabilityParams = {
    normalizeHttpErrors,
    reduxUpdate,
    data: {
      productOfferingId: productOffering,
    },
  };

  try {
    const response = yield call(getFttrAvailabilityBit, getFttrAvailabilityParams);
    const { available, products } = response;


    if (!available) {
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_PRODUCT_BY_ZONE));
      return megaMinderStatus.LOGICAL_ERROR;
    } if (available && !hasPackProductAvailable(products)) {
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.FUSION_MANDATORY));
      return megaMinderStatus.LOGICAL_ERROR;
    } if (available && hasPackProductAvailable(products)) {
      const fiberProduct = getFiberProductOfPackProduct(products);
      yield put(commonActions.setParentProductSelected(fiberProduct));
      yield put(commonActions.setInstallationAddress({
        fullAddress: fiberProduct.address.locationFullAddress,
        locationId: fiberProduct.address.id,
      }));
    }

    return response;
  } catch (error) {
    const errorResponse = megaMinderStatus.KO;
    errorResponse.errorInfo = error;

    return errorResponse;
  }
}
